// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import Llogo from '../img/Llogo.png';
// import { ArrowLeftOutlined } from '@ant-design/icons';
// import { useNavigate } from 'react-router-dom';

// const EventsWeb = () => {
  // const [eventData, setEventData] = useState([]);
  // const dist = sessionStorage.getItem("dist") || "320E";
  //   const navigate = useNavigate();

  // const getEvents = async () => {
  //   try {
  //     const res = await axios.post(`https://lionsdirectoryapi.emedha.in/notification/api/event/get`, {
  //       dist
  //     });
  //     setEventData(res.data);
  //   } catch (err) {
  //     console.error("Error fetching events:", err);
  //   }
  // };

  // useEffect(() => {
  //   getEvents();
  // }, []);

  // const formatDate = (dateString) => {
  //   if (!dateString) return "";
  //   const date = new Date(dateString);
  //   if (isNaN(date)) return "";
  //   const day = String(date.getDate()).padStart(2, "0");
  //   const month = String(date.getMonth() + 1).padStart(2, "0");
  //   const year = String(date.getFullYear()).slice(-2);
  //   return `${day}-${month}-${year}`;
  // };

//   return (
//     <div style={{
//       width: '365px',
//       minHeight: '557px',
//       maxHeight: '667px',
//       margin: '10px auto',
//       border: '1px solid #ccc',
//       borderRadius: '20px',
//       overflowY: 'scroll',
//       boxShadow: '0 0 10px rgba(0,0,0,0.2)',
//       backgroundColor: '#f8f9fa',
//       padding: '10px'
//     }}>
//        <div style={{
//       backgroundColor: '#fff',
//       padding: '15px',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'space-between'
//     }}>
//       <div style={{ display: 'flex', alignItems: 'center' }}>
//         <ArrowLeftOutlined
//           style={{
//             fontSize: '18px',
//             color: '#0e3972',
//             cursor: 'pointer',
//             marginRight: '10px'
//           }}
//           onClick={() => navigate('/home')} // or the correct route for HomeScreen
//         />
//         <h6 style={{ color: '#0e3972', fontWeight: 'bold', margin: 0 }}>Events</h6>
//       </div>
//     </div>

//       {eventData.map((event) => (
//         <div key={event.sno} style={{
//           marginTop: 10,
//           backgroundColor: 'white',
//           borderRadius: 4,
//           margin: '10px 4px',
//           boxShadow: '0 0 10px rgba(0,0,0,0.2)'
//         }}>
//           <div style={{ textAlign: 'center', padding: '10px' }}>
//             <img
//               src={Llogo}
//               alt="logo"
//               style={{ height: 100, width: 100 }}
//             />
//           </div>
//           <div style={{ backgroundColor: 'rgb(217, 221, 224)', borderRadius: 4, padding: 10 }}>
//             <p style={{ fontSize: 17, color: 'black', marginBottom: 5 }}>{event.name}</p>
//             <p style={{ fontSize: 17, color: 'black', marginBottom: 5 }}>{formatDate(event.eventdate)}</p>
//             <p style={{ fontSize: 17, color: 'black' }}>{event.venue}</p>
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default EventsWeb;


import React, { useEffect, useState } from 'react';
import { ChevronLeft, Calendar, MapPin, Clock } from 'lucide-react';
import axios from 'axios';

const EventsWeb = ({ onBack, styles }) => {
  // Data structure focused on Name, Event Date, and Venue
    const [eventData, setEventData] = useState([]);
  const dist = sessionStorage.getItem("dist") ;
 

  const getEvents = async () => {
    try {
      const res = await axios.post(`https://lionsdirectoryapi.emedha.in/notification/api/event/get`, {
        dist
      });
      setEventData(res.data);
    } catch (err) {
      console.error("Error fetching events:", err);
    }
  };

  useEffect(() => {
    getEvents();
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date)) return "";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear()).slice(-2);
    return `${day}-${month}-${year}`;
  };

  return (
    <div style={styles.scrollArea}>
      {/* Navigation Header */}
      <div 
        onClick={onBack} 
        style={{ padding: '15px 15px 5px', display: 'flex', alignItems: 'center', color: '#0033A0', cursor: 'pointer' }}
      >
        <ChevronLeft size={20} />
        <span style={{ fontSize: '14px', fontWeight: '600' }}>Back to Home</span>
      </div>

      {/* Page Title Section */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '15px', padding: '10px 15px 20px' }}>
        <div style={{ 
          backgroundColor: '#FFC20E', color: 'white', width: '45px', height: '45px', 
          borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' 
        }}>
          <Calendar size={24} />
        </div>
        <h1 style={{ fontSize: '24px', color: '#0033A0', margin: 0 }}>Events</h1>
      </div>

      {/* Events List */}
      <div style={{ padding: '0 15px' }}>
        {eventData.map((event, index) => (
          <div key={index} style={{
            backgroundColor: 'white', borderRadius: '12px', padding: '18px',
            marginBottom: '16px', border: '1px solid #eee', boxShadow: '0 2px 4px rgba(0,0,0,0.02)',
            position: 'relative'
          }}>
            {/* Event Type Tag (matching the blue/yellow labels in screenshot) */}
            <div style={{
              position: 'absolute', right: '15px', top: '15px',
              backgroundColor: event.type === 'meeting' ? '#0033A0' : '#FFC20E',
              color: event.type === 'meeting' ? 'white' : '#333',
              padding: '2px 10px', borderRadius: '4px', fontSize: '10px', fontWeight: 'bold'
            }}>
              {event.type}
            </div>

            {/* Event Name */}
            <h3 style={{ margin: '0 0 15px 0', fontSize: '18px', color: '#000', fontWeight: 'bold', maxWidth: '80%' }}>
              {event.name}
            </h3>

            {/* Event Date */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', color: '#555', marginBottom: '8px' }}>
              <Clock size={16} color="#0033A0" />
              <span style={{ fontSize: '13px' }}>{formatDate(event.eventdate)}</span>
            </div>

            {/* Venue */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', color: '#555' }}>
              <MapPin size={16} color="#0033A0" />
              <span style={{ fontSize: '13px' }}>{event.venue}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EventsWeb;
